(() => {
  const isPromoBanner = document.querySelector(".customPromoBanner");
  if (!isPromoBanner) {
    return;
  }
  const currentPath = window.location.pathname;
  //console.log("------------reset top css product-----------------:" + currentPath);
  const promoBanner = document.querySelector(".promo-banner");
  const element = document.querySelector(".is-width-wide");
  const initialTop = element.getBoundingClientRect().top;

  document.addEventListener("scroll", function () {
    const scrollTop = window.scrollY;
    const stickyNav = document.querySelector(".sticky_nav--stick");
    const isNarrowScreen = window.innerWidth < 798;

    if (promoBanner) {
      const height = window.getComputedStyle(promoBanner).height;
      if (isNarrowScreen) {
        //phone
        if (scrollTop >= initialTop) {
          element.classList.add("fixed");
          element.classList.remove("is-width-wide");
          element.style.top = height === "30px" ? "85px" : "56px";
        } else {
          element.classList.remove("fixed");
          element.classList.add("is-width-wide");
          element.style.top = "";
        }
      } else if (scrollTop >= initialTop) {
        element.classList.add("fixed");
        element.classList.remove("is-width-wide");
        if (
          stickyNav &&
          stickyNav.getAttribute("data-animation-state") === "open"
        ) {
          element.style.top = height === "30px" ? "76px" : "72px";
        } else {
          element.style.top = "0";
        }
      } else {
        element.classList.remove("fixed");
        element.classList.add("is-width-wide");
        element.style.top = "";
      }
    } else {
      if (isNarrowScreen) {
        //phone
        if (scrollTop >= initialTop) {
          element.classList.add("fixed");
          element.classList.remove("is-width-wide");
          element.style.top = "56px";
        } else {
          element.classList.remove("fixed");
          element.classList.add("is-width-wide");
          element.style.top = "";
        }
      } else if (scrollTop >= initialTop) {
        element.classList.add("fixed");
        element.classList.remove("is-width-wide");
        if (
          stickyNav &&
          stickyNav.getAttribute("data-animation-state") === "open"
        ) {
          element.style.top = "5em";
        } else {
          element.style.top = "0";
        }
      } else {
        element.classList.remove("fixed");
        element.classList.add("is-width-wide");
        element.style.top = "";
      }
    }
  });
})();
